/**
 * bgChara1
 */
import 'intersection-observer';
import {gsap, Expo} from 'gsap'

export default class bgChara1 {

  constructor() {
    // クラス名
    this.id = 'c-bgChara1';
    this.el = document.getElementById(this.id);

    if (this.el) {
      this.init();
    }
  }

  init() {
    this.isStarted = false;

    // アニメーションするDOM
    this.containers = [];
    const tmps = this.el.querySelectorAll('.c-bgChara1__con');
    tmps.forEach((el, i) => {
      this.containers.push({
        parent: el,
        line: el.querySelector('.c-bgChara1__conLine'),
        base: el.querySelector('.c-bgChara1__base'),
        grad: el.querySelector('.c-bgChara1__grad'),
        chara: el.querySelector('.c-bgChara1__chara'),
      });
    });

    // gsap timeline
    this.initTimeline();

    // イベント
    const options = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0.5
    };

    this.observer = new IntersectionObserver(this.intersect.bind(this), options);
    this.observer.observe(this.el);
  }

  initTimeline() {
    // start position
    this.params = [
      {brightness: 10, contrast: 0},
      {brightness: 10, contrast: 0},
      {brightness: 10, contrast: 0},
      {brightness: 10, contrast: 0},
      {brightness: 10, contrast: 0},
    ];

    this.tl = gsap.timeline({paused: true, onComplete: this.startComp.bind(this)});
    this.tl.addLabel('start', 0);

    this.containers.forEach((con, i) => {

      const rand = Math.random() * (0.4 - 0.1) + 0.1;

      this.tl.set(con.parent, {visibility: 'visible'}, 'start');

      this.tl.fromTo(con.line, {
        y: '-60%',
        opacity: 0,
      }, {
        duration: 0.9,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=' + rand);

      this.tl.fromTo(con.grad, {
        opacity: 0
      }, {
        duration: 0.9,
        opacity: 1,
        ease: Expo.easeOut
      }, 'start+=' + (rand + 0.1));

      this.tl.fromTo(con.chara, {
        visibility: 'visible',
        opacity: 0,
        y: '35%',
      }, {
        duration: 0.9,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=' + (rand + 0.2));

      this.tl.to(this.params[i], {
        duration: 0.9,
        brightness: 1,
        contrast: 1,
        ease: Expo.easeOut,
        onUpdate: function(chara, param) {
          /*gsap.set(chara, {
            '-webkit-filter': 'brightness(' + param.brightness + ') ' + 'contrast(' + param.contrast + ')',
            'filter': 'brightness(' + param.brightness + ') ' + 'contrast(' + param.contrast + ')',
          });*/
          gsap.set(chara, {
            '-webkit-filter': 'brightness(' + param.brightness + ')',
            'filter': 'brightness(' + param.brightness + ')',
          });
        },
        onUpdateParams: [con.chara, this.params[i]]
      }, 'start+=' + (rand + 0.2));

    });
  }

  intersect(entries) {
    entries.forEach((entry) => {
      if (entry.target.id === this.id && entry.isIntersecting === true) {
        // 表示スタート
        requestAnimationFrame(this.start.bind(this));
      }
    });
  }

  start() {
    if (this.isStarted) return;
    this.isStarted = true;

    this.observer.disconnect();
    delete this.observer;

    this.tl.play(0);
  }

  startComp() {
    this.tl.clear();
    delete this.tl;
    delete this.containers;
  }
}
